import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  PasswordResetStoreVerificationCode,
  LoginRedirect,
  ForgotPasswordRedirect,
  SendResetPasswordEmail,
  ResetPasswordRequest,
  ResetPasswordStore
} from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-authentication-codeverification-container',
  styleUrls: ['./codeverification.container.component.scss'],
  templateUrl: './codeverification.container.component.html'
})
export class CodeVerificationContainerComponent implements OnInit {
  email$: Observable<string>;
  @Output()
  goBackClicked = new EventEmitter();

  @Output()
  onSetVerificationClicked = new EventEmitter();

  @Output()
  onForgotPasswordClicked = new EventEmitter();

  labelPrefix = 'ARC_SHARED_COMPONENTS_FEATURE_';
  isPasswordSend$;
  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.isPasswordSend$ = this.store.pipe(
      select(ResetPasswordStore),
      map(store => store.resetPasswordEmailSent)
    );
    this.email$ = this.store.pipe(
      select(ResetPasswordStore),
      map(x => x.email)
    );
  }

  onSetVerification($event) {
    // this.store
    this.store.dispatch(new PasswordResetStoreVerificationCode($event));
    this.onSetVerificationClicked.emit();
  }

  onGoBack() {
    this.goBackClicked.emit();
    this.store.dispatch(new LoginRedirect(null));
  }

  goToForgotPassword($event) {
    this.onForgotPasswordClicked.emit();
    this.store.dispatch(new ForgotPasswordRedirect(null));
  }

  resendCodeClicked(event) {
    if (event) {
      this.store.dispatch(
        new SendResetPasswordEmail({ email: event } as ResetPasswordRequest)
      );
    }
  }
}
